import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/branch-places'

class BranchPlaceApi {
  getList(branchUuid, page, size, sort) {
    const url = new URL(API_URL) // Use URL object for easier parameter management

    url.searchParams.set('actualPage', page)
    url.searchParams.set('perPage', size)
    url.searchParams.set('filter[branch]', branchUuid)

    if (sort && sort.length > 0) {
      sort.forEach(item => {
        url.searchParams.set(`sort[${item.field}]`, item.dir)
      })
    }

    return axios.get(url.toString(), {
      headers: authHeader()
    })
  }

  sortOrder(uuid, data) {
    return axios.put(API_URL + '/' + uuid + '/_sort-order', data, { headers: authHeader() })
  }

  cloneBranchPlace(uuid) {
    return axios.put(API_URL + '/' + uuid + '/_clone', {}, { headers: authHeader() })
  }

  getListAll(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createBranchPlace(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  editBranchPlace(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }
}

export default new BranchPlaceApi()
